import React from 'react';

const Channels = () => {
  return (
    <div className='center'>
      This channel doesn't feature any other channels.
    </div>
  );
};

export default Channels;
